import { render, staticRenderFns } from "./PackageGroup.vue?vue&type=template&id=f383bd46&scoped=true"
import script from "./PackageGroup.vue?vue&type=script&lang=js"
export * from "./PackageGroup.vue?vue&type=script&lang=js"
import style0 from "./PackageGroup.vue?vue&type=style&index=0&id=f383bd46&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f383bd46",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f383bd46')) {
      api.createRecord('f383bd46', component.options)
    } else {
      api.reload('f383bd46', component.options)
    }
    module.hot.accept("./PackageGroup.vue?vue&type=template&id=f383bd46&scoped=true", function () {
      api.rerender('f383bd46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financeStatistical/PackageGroup.vue"
export default component.exports